import { createFileRoute } from '@tanstack/react-router';
import { ExchangeSettingsPage } from '@/features/currency/exchange-settings-page';

export const Route = createFileRoute('/_app/settings/exchange')({
  component: ExchangeSettingsPage,
});
